import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

class ResourceSavingSceneView extends React.PureComponent {
  constructor(props) {
    super();

    this.state = {
      awake: props.visible,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.visible && !this.state.awake) {
      this.setState({awake: true});
    }
  }

  render() {
    const { awake } = this.state;
    const {
      visible,
      props,
      factory,
      component: Component,
    } = this.props;

    if (!awake) {
        return null;
    }
    return (
      <View visible={visible} style={this.props.style || styles.container}>
        {factory ? factory(props) : <Component {...props}/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
      position: 'absolute',
      overflow: 'hidden',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
  },
});

export default ResourceSavingSceneView;
